import { Component, OnInit } from '@angular/core';
import { MultiCheckBoxBaseComponent } from 'src/app/base/components/fields/multi-checkbox-base.component';

@Component({
  selector: '[app-easysuite-multi-checkbox]',
  templateUrl: './easysuite-multi-checkbox.component.html',
  styleUrls: ['./easysuite-multi-checkbox.component.css']
})
export class EasysuiteMultiCheckboxComponent extends MultiCheckBoxBaseComponent implements OnInit {

  constructor() { super() }

  ngOnInit(): void {
    super.ngOnInit();
  }

  // This function used by html to sort choices by order ASC
  SortByOrder = (a: any, b: any): number => {
    return a.value.order - b.value.order
  };
}
